import { roomsProgrammingReducers } from './quickstart-rooms.service';

export const QUICKSTART_ROOMS_REDUCERS = {
  roomsProgramming: roomsProgrammingReducers
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-rooms/quickstart-rooms.store.ts